import React from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { useProfileModel } from './model';
import { ProfileView } from './view';

export const ProfileWidget: React.FC = () => {
  const { doLogout } = useAuth();
  const { state } = useProfileModel();

  return <ProfileView state={state} onLogout={doLogout} />;
};

